import { Injectable, inject } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';
import { CommonApiService } from '../services/api/common-api.service';
import { UserStorage } from '../services/storage/local-storage.model';
import { LocalStorageService } from '../services/storage/local-storage.service';
import { ConfigService } from '../services/config/config.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard extends KeycloakAuthGuard {
  protected readonly router: Router;
  protected readonly route = inject(ActivatedRoute);
  protected readonly keycloak: KeycloakService;
  protected localStorageService = inject(LocalStorageService);
  protected commonApiService = inject(CommonApiService);
  protected config = inject(ConfigService);

  constructor() {
    const router = inject(Router);
    const keycloak = inject(KeycloakService);

    super(router, keycloak);
  
    this.router = router;
    this.keycloak = keycloak;
  }

  async isAccessAllowed(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    if (!this.authenticated) {
      await this.keycloak.login({
        redirectUri: globalThis.location.origin + state.url
      });
    }
    let user: UserStorage = this.localStorageService.getUser();

    if (user) {
      return this.authenticated;
    }
    const TOKEN_DATA = this.keycloak.getKeycloakInstance();

    const userData = this.commonApiService.getMembersRolesOnLogin(TOKEN_DATA.token);

    userData.subscribe((res) => {
      const coreMemberOf = res.sircles.find((sircle) => sircle.coreMember);
      user = {
        username: TOKEN_DATA.tokenParsed['preferred_username'],
        isAdmin: res['admin'],
        menu: res['sircles'],
        loggedID: res['id'],
        isCoreMemberOf: coreMemberOf?.id ? coreMemberOf.id : '',
        avatar: `${this.config.savatarUrl}/${TOKEN_DATA.tokenParsed['preferred_username']}`
      };
      this.localStorageService.setUser(user);

      const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
      this.router.navigateByUrl(returnUrl);
      return this.authenticated;
    });
  }
}
